import React from 'react';
import { motion } from 'framer-motion';
import { cn } from '../../utils/cn';

const variants = {
  primary: 'bg-brand-600 text-white hover:bg-brand-700 active:bg-brand-800 shadow-sm border border-transparent font-medium',
  secondary: 'bg-indigoBrand-600 text-white hover:bg-indigoBrand-700 active:bg-indigoBrand-800 shadow-sm border border-transparent font-medium',
  glow: 'bg-brand-600 text-white hover:bg-brand-700 active:bg-brand-800 shadow-sm hover:shadow-md border border-brand-500 font-semibold',
  outline: 'bg-white dark:bg-slate-900 text-slate-800 dark:text-slate-100 border border-slate-300 dark:border-slate-700 hover:bg-slate-50 dark:hover:bg-slate-800 hover:border-slate-400 font-medium',
  ghost: 'bg-transparent text-slate-700 dark:text-slate-200 hover:bg-slate-100 dark:hover:bg-slate-800 font-medium',
};

const Button = ({ children, variant = 'primary', className, ...props }) => {
  return (
    <motion.button
      whileHover={{ y: -1 }}
      whileTap={{ y: 0 }}
      transition={{ duration: 0.15 }}
      className={cn(
        'inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-xl transition-all duration-200 font-sans text-sm tracking-normal focus:outline-none focus:ring-2 focus:ring-brand-500/40 focus:ring-offset-1',
        variants[variant] || variants.primary,
        className
      )}
      {...props}
    >
      {children}
    </motion.button>
  );
};

export default Button;
